import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (project) => async (dispatch) => {

  dispatch(push(getTeamUrl(`projects/${project.id}/view`)))
  
}